import { render } from "./ModalComponent.vue?vue&type=template&id=6287ca10&scoped=true"
import script from "./ModalComponent.vue?vue&type=script&lang=js"
export * from "./ModalComponent.vue?vue&type=script&lang=js"

import "./ModalComponent.vue?vue&type=style&index=0&id=6287ca10&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6287ca10"]])

export default __exports__